<template>
  <div class="tw-relative">
    <div class="tw-flex tw-gap-4" data-testid="adjustments-account-edit-name">
      <SfInput
        :model-value="selectedAccount.number"
        type="text"
        data-testid="edit-account-number"
        :has-floating-label="true"
        :disabled="true"
        :label="numberLabel"
      />
      <SfInput
        v-model="selectedAccount.name"
        type="text"
        data-testid="edit-account-name"
        :has-floating-label="true"
        :has-error="!!nameError"
        :label="nameLabel"
      />
    </div>
    <div class="!tw-mt-2 tw-absolute tw-bottom-0 tw-left-0 tw-translate-y-full">
      <SfInputError v-if="error">{{ error }}</SfInputError>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { computed } from 'vue'

import type { SubAdjustmentRowAccount } from '@app/application/adjustments/types'
import SfInput from '@app/shared/vue/components/sf-input/sf-input.vue'
import SfInputError from '@app/shared/vue/components/sf-input/sf-input-error.vue'

interface Props {
  error?: string
  modelValue: SubAdjustmentRowAccount
}

const props = withDefaults(defineProps<Props>(), {
  error: '',
  modelValue: () => ({} as SubAdjustmentRowAccount),
})

const emit =
  defineEmits<{
    'update:modelValue': [value: SubAdjustmentRowAccount]
  }>()

const selectedAccount = useVModel(props, 'modelValue', emit, {
  passive: true,
  deep: true,
})

const numberLabel = window.I18n.t('adjustment.adjustment_account.number')
const nameLabel = window.I18n.t('adjustment.adjustment_account.name')

const nameError = computed(() => {
  return !selectedAccount.value.name ? props.error : ''
})
</script>
